<template>
  <div class="body">
    <toast ref="toast"></toast>
    <div v-for="(item,index) in commentList" :key="index" class="list">
      <div class="avatar" :data-uid="item.uid" :data-certified_type="item.certified_type" :data-certified_id="item.certified_id" @click="gohome">
        <img :src="item.avatar.u"/>
        <img v-if="item.certified_type == 1 || item.certified_type == 10 || item.certified_type == 11 || item.certified_type == 14" class="icon" src="https://static.soyoung.com/sy-pre/202004031-1585897801571.png"/>
      </div>
      <div class="main">
        <div class="user_name" :data-uid="item.uid" :data-certified_type="item.certified_type" :data-certified_id="item.certified_id" @click="gohome">{{item.user_name}}<span v-if="item.post_author == 1"><img src="https://static.soyoung.com/sy-pre/lark20201225-111308-1608865800705.png"/></span></div>
        <div class="content">
          <div v-if="item.content" v-html="item.content"></div>
          <div class="img">
            <template v-for="(item,i) in item.comment_imgs" :key="i">
                <img :src="item.u || item.url" :data-i="i" :data-index="index" @click="shoImg"/>
            </template>
          </div>
        </div>
        <div class="create_date_str">{{item.create_date_str || '刚刚'}}</div>
        <template  v-if="pingIndex == index">
          <editor :post_id="post_id" :reply_id="item_id" :comment_id="comment_id" @getupdate="getupdate" :user_name="item.user_name"></editor>
        </template>
        <div class="right">
          <div class="del" v-if="uid == item.uid" @click="del" :data-item_id="item.item_id" :data-comment_id="item.comment_id"></div>
          <div class="pinglun" @click="showPinglun" :data-index="index" :data-item_id="item.item_id" :data-comment_id="item.comment_id"></div>
          <img v-if="item.is_favor == 1" class="zanimg" src="https://static.soyoung.com/sy-pre/1sqkgv4i0hab7-1608711000699.png"/>
          <div v-else class="zan" :data-index="index" :data-reply_id="item.item_id" :data-comment_id="item.comment_id" @click="zan"></div>
          <div class="ding_cnt">{{item.ding_cnt}}</div>
        </div>
      </div>
    </div>
    <pagination
      v-if="total > 10"
      :currentPage="page"
      :limit="limit"
      type="min"
      :totalCount="total"
      @turn="getpageupdate"></pagination>
    <swiper v-if="imglist.length > 0" :img="imglist" :index="imglistindex" @close="close"></swiper>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { delcomment, commentindex,commentfavorites } from "@/views/post/api/index.ts";
import editor from "@/views/post/components/editor.vue";
import pagination from "@/views/post/components/pagination.vue";
import swiper from "@/views/post/components/swiper/swiper.vue";
import toast from "@/views/post/components/toast.vue";
export default defineComponent({
  components: {
    editor,
    pagination,
    swiper,
    toast
  },
  props: {
    comment: {
      type: Array
    },
    post_id: {
      type: String
    },
    comment_cnt: {
      type: Number
    },
    index: {
      type: Number
    },
  },
  data(){
    return {
      uid: parseInt((window.globalData as any).uid || 0),
      commentList: this.comment,
      pingIndex: -1,
      item_id: "",
      comment_id:"",
      limit: 10,
      page: 1,
      total: this.comment_cnt,
      imglist:[],
      imglistindex:0
    }
  },
  
  setup() {
    const gohome: (e: any) => void = (e: any) => {
      const uid = e.currentTarget.dataset.uid
      if(!Number(uid)) return
      const certified_type = e.currentTarget.dataset.certified_type
      const certified_id = e.currentTarget.dataset.certified_id
      let url = ""
      if(certified_type == 2){
        url = `/hospital/${certified_id}/`
      } else if(certified_type == 3){
        url = `/doctor/${certified_id}/zhuye/`
      } else {
        url = `/u${uid}`
      }
      window.open(`${window.location.origin}${url}`)
    };
    return {
      gohome
    };
  },
  watch:{
    comment: {
      handler() {
        this.commentList = this.comment
      }
    },
    comment_cnt:{
      handler() {
        this.total = this.comment_cnt
      }
    }
  },
  methods:{
    del(e: any){
      if(confirm('确定要删除吗') == true){
        const comment_id = e.currentTarget.dataset.comment_id
        const item_id = e.currentTarget.dataset.item_id
        delcomment({
          item_id,
          comment_id,
          class_id: 8,
          primary_id: this.post_id,
        }).then(({errorCode,errorMsg})=>{
          if(errorCode == 0){
          this.pingIndex = -1
          commentindex({
            page: 1,
            num: 10,
            item_id,
            class_id: 8,
          }).then(({errorCode,errorMsg,responseData}) => {
            if (errorCode === 0) {
              this.commentList = responseData.list
            } else {
              (this.$refs.toast as any).show(errorMsg)
            }
          })
          } else {
            (this.$refs.toast as any).show(errorMsg)
          }
        })
      }
    },
    showPinglun(e: any){
      this.pingIndex = e.currentTarget.dataset.index
      this.comment_id = e.currentTarget.dataset.comment_id
      this.item_id = e.currentTarget.dataset.item_id
    },
    getpageupdate(e = 1){
      this.pingIndex = -1
      this.page = e
      commentindex({
        page: this.page,
        num: this.limit,
        item_id: this.item_id,
        class_id: 8,
      }).then(({errorCode,errorMsg,responseData}) => {
        if (errorCode === 0) {
          this.commentList = responseData.list
          //this.total = responseData.total
          const top = ((document.querySelectorAll(".comment>.list") as any)[(this.index as any)] as any ).offsetTop - 100;
          document.body.scrollTop = top
          document.documentElement.scrollTop = top
        } else {
          (this.$refs.toast as any).show(errorMsg)
        }
      })
    },
    getupdate(comment: Array<any>){
      (this.commentList as Array<any>).splice(this.pingIndex * 1 + 1,0,comment)
      this.pingIndex = -1;
    },
    zan(e: any){
      const comment_id = e.currentTarget.dataset.comment_id
      const reply_id = e.currentTarget.dataset.reply_id
      const index = e.currentTarget.dataset.index
      if (this.uid === 0) {
        window.sy.login.popup()
        return
      }
      commentfavorites({
        post_id: this.post_id,
        reply_id,
        type: 1,
        comment_id
      }).then(({errorCode,errorMsg}) => {
        if (errorCode === 0) {
          (this.commentList as any)[index].is_favor = 1;
          (this.commentList as any)[index].ding_cnt = parseInt((this.commentList as any)[index].ding_cnt) + 1
        } else {
          (this.$refs.toast as any).show(errorMsg)
        }
      })
    },
    shoImg(e: any){
      const index = e.currentTarget.dataset.index
      this.imglistindex = e.currentTarget.dataset.i
      const temp = (this.commentList as any)[index].comment_imgs
      this.imglist = temp
    },
    close(){
      this.imglist = []
    }
  },
  created(){
    this.item_id = (this.commentList as any)[0] ? (this.commentList as any)[0].item_id : ""
  }
});
</script>
<style lang="less" scoped>
.body{
  background: #F7F7F7;
  border-radius: 4px;
  margin-top: 10px;
}
.list{
  display: flex;
  padding: 10px 0;
  border-bottom: 1px dashed #cccccc;
  margin: 0 10px;
  &:last-child{
    border-bottom: 0
  }
  .avatar{
    width: 40px;
    height: 40px;
    cursor: pointer;
    position:relative;
    img{
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 50% 50% 2px 50%;
    }
    .icon{
      position:absolute;
      bottom:0;
      right:0;
      width: 12px;
      height: 12px;
      border-radius:0;
    }
  }
  .main{
    margin-left: 10px;
    width: 550px;
    position: relative;
    .user_name{
      font-family: PingFangSC-Regular;
      font-size: 13px;
      color: #777777;
      cursor: pointer;
      display: flex;
      img{
        margin-left: 5px;
        width: 28px;
      }
    }
    .content{
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #333333;
      line-height: 18px;
      margin-top: 5px;
      max-width:440px;
      .img{
        cursor: pointer;
        width: 510px;
        img{
          border-radius: 4px;
          width: 96px;
          height: 96px;
          margin-top: 5px;
          margin-right: 5px;
          object-fit: cover;
          vertical-align: top;
        }
      }
    }
    .create_date_str{
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #AAABB3;
      margin-top: 5px;
    }
    .right{
      position: absolute;
      right: 0px;
      top: 2px;
      display: flex;
      align-items: center;
      .del{
        display: inline-block;
        width: 14px;
        height: 14px;
        margin-right: 20px;
        background-image: url("https://static.soyoung.com/sy-pre/lark20201224-165931-1608797400718.png");
        background-size: 14px 14px;
        cursor: pointer;
        &:hover{
          background-image: url("https://static.soyoung.com/sy-pre/lark20201224-170940-1608797400718.png");
        }
      }
      .pinglun{
        display: inline-block;
        width: 14px;
        height: 14px;
        margin-right: 20px;
        background-image: url("https://static.soyoung.com/sy-pre/3cgw6gdi9y299-1608711000699.png");
        background-size: 14px 14px;
        cursor: pointer;
        &:hover{
          background-image: url("https://static.soyoung.com/sy-pre/2uyhglimahwb4-1608711000699.png");
        }
      }
      .zan{
        display: inline-block;
        width: 14px;
        height: 14px;
        background-image: url("https://static.soyoung.com/sy-pre/266sg06l8wafk-1608711000699.png");
        background-size: 14px 14px;
        cursor: pointer;
        &:hover{
          background-image: url("https://static.soyoung.com/sy-pre/1bky3pg8jq7id-1608711000699.png");
        }
      }
      .ding_cnt{
        min-width: 30px;
        line-height: 16px;
        float: right;
        margin-left: 5px;
        color:#777777
      }
      .zanimg{
        width: 13px;
      }
    }
  }
}
</style>
